const BIFROST_CONTAINER_ID = 'bifrost-container-id';

export default BIFROST_CONTAINER_ID;
